import config from 'config/default';
import { Roles } from 'enums';
import _ from 'lodash';
import useUserStore from 'stores/user-store';

export interface Token {
  accessToken: string;
  refreshToken?: string;
  /** Token lifetime in seconds as returned by the backend. */
  expiresIn?: number | string;
  tokenType?: string;
}

export interface User {
  email: string;
  language: string;
  lastLogin: string;
  role: Roles;
}

export const useExtensionAuth = () => {
  const { basics, token } = useUserStore((state) => ({ basics: state.basics, token: state.token }));

  // production IDs
  const extensionIdChrome = config.extensionIdChrome;
  const extensionIdEdge = config.extensionIdEdge;

  const extensionSignIn = (token: Token, user: User) => {
    try {
      chrome?.runtime?.sendMessage(extensionIdChrome, { action: 'sign-in', body: { token, user } })?.catch(() => false);
      chrome?.runtime?.sendMessage(extensionIdEdge, { action: 'sign-in', body: { token, user } })?.catch(() => false);
    } catch (e) {
      console.log(e);
    }
  };

  const extensionSignInStoredValues = () => {
    try {
      if (!_.isNil(token) && !_.isNil(basics)) {
        chrome?.runtime?.sendMessage(extensionIdChrome, { action: 'sign-in', body: { token, user: basics } })?.catch(() => false);
        chrome?.runtime?.sendMessage(extensionIdEdge, { action: 'sign-in', body: { token, user: basics } })?.catch(() => false);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const extensionSignOut = () => {
    try {
      chrome?.runtime?.sendMessage(extensionIdChrome, { action: 'sign-out' })?.catch(() => false);
      chrome?.runtime?.sendMessage(extensionIdEdge, { action: 'sign-out' })?.catch(() => false);
    } catch (e) {
      console.log(e);
    }
  };

  return { extensionSignIn, extensionSignInStoredValues, extensionSignOut };
};
